/*
 * Copyright (c) 2026. Tooling Team
 */

import HeaderService from "../services/headerService";
import { useSelector, useDispatch } from "react-redux";
import {
  useGetAllMedDomainBuildsQuery,
  useGetMedDomainBuildSummaryByIdQuery,
  useGetMedDomainBuildDetailMutation,
} from "../app/services/medDomainApi";
import { useEffect, useRef } from "react";
import {
  setMedDomainBuildRowData,
  setMedDomainBuildSummaryData,
  setMedDomainBuildDetailData,
} from "../app/slices/medDomain.slice";

export default (buildId) => {
  const {
    medDomainBuildRowData,
    medDomainBuildSummaryData,
    medDomainBuildDetailData,
  } = useSelector((state) => state.medDomain);

  const dispatch = useDispatch();
  const { data: buildsData } = useGetAllMedDomainBuildsQuery();
  const { data: summaryData } = useGetMedDomainBuildSummaryByIdQuery(buildId, {
    skip: !buildId,
  });
  const [getMedDomainBuildDetail, { data: detailData, isLoading }] =
    useGetMedDomainBuildDetailMutation();
  const headerService = new HeaderService();
  const calledRef = useRef();

  useEffect(() => {
    if (Array.isArray(buildsData) && buildsData.length > 0) {
      dispatch(setMedDomainBuildRowData(buildsData));
    }
  }, [buildsData, dispatch]);

  useEffect(() => {
    if (Array.isArray(summaryData)) {
      dispatch(setMedDomainBuildSummaryData(summaryData));
    }
  }, [summaryData, dispatch]);

  useEffect(() => {
    if (buildId && calledRef.current !== buildId) {
      getMedDomainBuildDetail({ buildId, mapUsed: "addon" });
      calledRef.current = buildId;
    }
  }, [buildId, getMedDomainBuildDetail]);

  const fetchMedDomainBuildDetail = (mapUsed) => {
    if (!buildId) {
      return;
    }

    getMedDomainBuildDetail({ buildId, mapUsed });
  };

  useEffect(() => {
    if (detailData) {
      dispatch(setMedDomainBuildDetailData(detailData));
    }
  }, [detailData, dispatch]);

  return {
    state: {
      medDomainBuildRowData,
      medDomainBuildSummaryData,
      medDomainBuildDetailData,
    },
    headerService,
    fetchMedDomainBuildDetail,
    isLoadingDetail: isLoading,
  };
};
